import request from '../helpers/request';

const updateRequestExecuteTime = async (requestId, data) => {
  return await request.put(
    `/Request/set_execute_date/${requestId}`,
    data,
    'Не удалось обновить время выполнения'
  );
};

export default updateRequestExecuteTime;
